import { BodyText, Card, Heading, Layout } from '@postscript/components';
import React from 'react';
import styled from 'styled-components';

type DisplayCardSize = 'small' | 'medium';

export interface DisplayCardProps extends React.HTMLAttributes<HTMLElement> {
  actions?: React.ReactNode;
  advancedDescription?: React.ReactNode;
  colspan?: number;
  description?: React.ReactNode;
  emoji?: string;
  heading: string;
  nocard?: boolean;
  size?: DisplayCardSize;
}

const StyledInnerCard = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  a:focus {
    outline: none;
    color: var(--link-color-hover);
  }
  a:active {
    opacity: 0.75;
  }

  > p:not(:last-child) {
    margin-bottom: var(--spacing-4);
  }
`;

const StyledEmoji = styled.img<{ size: DisplayCardSize }>`
  display: block;
  height: 24px;
  width: 24px;
`;

const StyledHeadingLayout = styled(Layout)`
  margin-bottom: var(--spacing-2);
`;

export const DisplayCardButtons = styled(Layout)`
  margin-top: auto;

  a {
    text-decoration: none;
  }
`;

const DisplayCard = React.forwardRef<HTMLDivElement, DisplayCardProps>(
  (
    {
      actions,
      advancedDescription,
      colspan = 1,
      description,
      emoji,
      heading,
      nocard = false,
      size = 'small',
      ...props
    },
    ref,
  ) => {
    const contents = (
      <StyledInnerCard>
        <StyledHeadingLayout gap="var(--spacing-2)" valign="center">
          {emoji && <StyledEmoji size={size} src={`/img/emoji/${emoji}.svg`} />}
          <Heading size={size === 'medium' ? 'x-small' : 'xx-small'}>
            {heading}
          </Heading>
        </StyledHeadingLayout>
        {advancedDescription || <BodyText size={size}>{description}</BodyText>}
        {actions}
      </StyledInnerCard>
    );
    return nocard ? (
      <div className={`span-${colspan}`} ref={ref} {...props}>
        {contents}
      </div>
    ) : (
      <Card className={`span-${colspan}`} ref={ref} size={size} {...props}>
        {contents}
      </Card>
    );
  },
);

export default DisplayCard;
